import * as React from 'react';
import Svg, { Path, Line, Rect } from 'react-native-svg';
interface AddPhoneNumberProps {
  height?: number;
  width?: number;
  color?: string;
}
export function AddPhoneNumber({ height = 40, width = 40, color = '#64BAAF' }: AddPhoneNumberProps) {
  return (
    <Svg width={width} height={height} viewBox="0 0 137 51" fill="none">
      <Path
        d="M5.52 38.77C4.48 41.2 3.95 43.78 3.95 46.44C3.95 47.3 4.66 48 5.54 48H42.43C43.3 48 44.01 47.3 44.01 46.44C44.01 43.78 43.48 41.2 42.44 38.77C41.43 36.43 39.98 34.32 38.15 32.52C36.31 30.71 34.16 29.29 31.78 28.3C29.31 27.27 26.68 26.75 23.98 26.75C21.28 26.75 18.65 27.27 16.18 28.3C13.8 29.29 11.65 30.71 9.82 32.52C7.98 34.32 6.53 36.43 5.52 38.77ZM23.98 29.87C28.48 29.87 32.72 31.59 35.9 34.72C38.71 37.48 40.4 41.04 40.76 44.88H7.2C7.56 41.04 9.25 37.48 12.06 34.72C15.24 31.59 19.48 29.87 23.98 29.87Z"
        fill={color}
      />
      <Path
        d="M23.98 22.97C29.58 22.97 34.14 18.49 34.14 12.99C34.14 7.48 29.58 3 23.98 3C18.38 3 13.82 7.48 13.82 12.99C13.82 18.49 18.38 22.97 23.98 22.97ZM23.98 6.12C27.83 6.12 30.97 9.2 30.97 12.99C30.97 16.77 27.83 19.85 23.98 19.85C20.13 19.85 17 16.77 17 12.99C17 9.2 20.13 6.12 23.98 6.12Z"
        fill={color}
      />
      <Line x1={113.997} y1={44.4834} x2={126.155} y2={44.4834} stroke={color} strokeWidth={3} strokeLinecap="round" />
      <Rect transform="translate(105.58 1.5)" width={29} height={48} rx={5.5} stroke={color} strokeWidth={3} />
      <Path d="M97.24 25H87.24" stroke={color} strokeWidth={2} strokeLinecap="round" strokeDasharray="4 4" />
      <Path
        d="M84.08 25C84.08 31.08 78.93 36 72.58 36C66.23 36 61.08 31.08 61.08 25C61.08 18.92 66.23 14 72.58 14C78.93 14 84.08 18.92 84.08 25Z"
        fill={color}
      />
      <Path d="M67.08 26.17V23.83H78.08V26.17H67.08ZM71.29 30V20H73.86V30H71.29Z" fill="white" />
      <Path d="M56.92 25L46.92 25" stroke={color} strokeWidth={2} strokeLinecap="round" strokeDasharray="4 4" />
    </Svg>
  );
}
export default AddPhoneNumber;
